import { SET_LEVEL, SET_START_LEVEL, SET_INTRODUCED, SET_OPTIONS, SELECT_SIZE, SET_SHAPES, PAUSE } from './actions';
import { LOADING_GAME, SHOW_INTRO } from './actions';
import { SET_SCORE, SET_TIME_LEFT, SET_LEVELS_COMPLETED, UPDATE_STATS } from './actions';
import { GOTO_PAGE } from '../../HOME/REDUX/actions';
import * as f from '../logic';
import _ from 'lodash';
import { dbdel } from '../../HOME/utils';
import { HELPED_KEY } from '../const';

export default (state = {}, action) => {
  switch (action.type) {
    case SELECT_SIZE:
      return { ...state, size: action.size };
    case SET_LEVELS_COMPLETED:
      return { ...state, levelsCompleted: action.levelsCompleted };
    case SET_LEVEL:
      return { ...state, level: action.level };
    case SET_START_LEVEL:
      return { ...state, startLevel: action.startLevel };
    case GOTO_PAGE:
      return { ...state, page: action.payload.page };
    case SET_TIME_LEFT:
      const time = action.timeLeft;
      return { ...state, timeLeft: time === undefined ? f.levelInfo(state.level).time : time };
    case SET_SCORE:
      const { steps, score } = action.payload;
      return { ...state, steps, score };
    case SET_INTRODUCED:
      return { ...state, introduced: action.introduced };
    case UPDATE_STATS:
      return onUpdateStats(state, action.stats);
    case SET_OPTIONS:
      return { ...state, options: action.options || {} };
    case LOADING_GAME:
      return { ...state, loadingGame: action.on, paused: true };
    case SHOW_INTRO:
      return { ...state, intro: action.show };
    case SET_SHAPES:
      return { ...state, shapes: action.shapes };
    case PAUSE:
      return { ...state, paused: action.on };
    case HELPED_KEY:
      return { ...state, helped: true };
    default:
      return state;
  }
};

function onUpdateStats(state, stats) {
  if (!stats) {
    dbdel(f.statsKey(state));
    stats = { plays: 0, aggScore: 0, aveScore: 0, bestScore: 0 };
  } else {
    let { plays, aggScore, bestScore } = stats;

    const aveScore = plays === 0 ? 0 : _.round((aggScore || 0) / plays);

    stats = { plays, aggScore, aveScore, bestScore };
  }

  return { ...state, stats };
}
